
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wheels/transportbil/volkswagen-transporter",
      function () {
        return require("private-next-pages/wheels/transportbil/volkswagen-transporter.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wheels/transportbil/volkswagen-transporter"])
      });
    }
  